import type { LocationQueryValue } from 'vue-router'

import { TimeFrameOptionsEnum } from './types'

export interface TimeframeDateRange {
  updatedSince: string | null
  updatedTo: string | null
}

export function timeframeDateRange(timeframe: LocationQueryValue | undefined, referenceDate: Date = new Date()): TimeframeDateRange {
  if (!timeframe || timeframe === TimeFrameOptionsEnum.NONE) {
    return { updatedSince: null, updatedTo: null }
  }

  const since = new Date(referenceDate)
  const to = new Date(referenceDate)

  switch (timeframe) {
    case TimeFrameOptionsEnum.LAST_3_MONTH:
      since.setMonth(since.getMonth() - 3)
      break
    case TimeFrameOptionsEnum.LAST_6_MONTH:
      since.setMonth(since.getMonth() - 6)
      break
    case TimeFrameOptionsEnum.LAST_12_MONTH:
      since.setFullYear(since.getFullYear() - 1)
      break
    case TimeFrameOptionsEnum.OLDER_THAN_12_MONTH:
      to.setFullYear(to.getFullYear() - 1)
      return { updatedSince: null, updatedTo: to.toISOString() }
    default:
      since.setDate(since.getDate() - 30)
      break
  }

  return { updatedSince: since.toISOString(), updatedTo: to.toISOString() }
}
